import {
    CloudUploadOutlined,
    Loading3QuartersOutlined,
} from "@ant-design/icons";
import { Badge, Button } from "antd";
import { useCallback, useMemo, useState } from "react";

import { UploadRetryModal } from "@/components/Modals/UploadRetryModal";
import { useAppSelector } from "@/hooks/redux";
import { QueueTaskStatus } from "@/hooks/useAsyncTaskQueue";

import { StyledUploadIndicator } from "./Styled";

export const UploadIndicator = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { candidatesCount: photoCandidates, progress: photoProgress } =
        useAppSelector((state) => state.offline.photoUploadRetry);

    const { requestQueue, requestQueueStatus } = useAppSelector(
        (state) => state.offline,
    );

    const handleOpenModal = useCallback(() => setIsModalOpen(true), []);
    const handleCloseModal = useCallback(() => setIsModalOpen(false), []);

    const { badgeCount, showSpinner, photoCount, requestCount } =
        useMemo(() => {
            const photoIsRunning = photoProgress.isRunning;
            const photoRemaining = Math.max(
                0,
                photoProgress.totalCount - photoProgress.completedCount,
            );

            const photoBadge = photoIsRunning
                ? photoRemaining
                : photoCandidates;

            const requestIsRunning = requestQueueStatus.isRunning;

            const requestCandidates = requestQueue.length;

            const requestRemaining = requestQueue.filter(
                (item) => item.status === QueueTaskStatus.Pending,
            ).length;

            const requestBadge = requestIsRunning
                ? requestRemaining
                : requestCandidates;

            return {
                badgeCount: photoBadge + requestBadge,
                showSpinner: photoIsRunning || requestIsRunning,
                requestCount: requestBadge,
                photoCount: photoBadge,
            };
        }, [
            photoProgress,
            photoCandidates,
            requestQueueStatus.isRunning,
            requestQueue,
        ]);

    return (
        <>
            <StyledUploadIndicator>
                <Badge count={badgeCount} size="small">
                    <Button
                        icon={
                            showSpinner ? (
                                <Loading3QuartersOutlined spin />
                            ) : (
                                <CloudUploadOutlined />
                            )
                        }
                        type="text"
                        onClick={handleOpenModal}
                    />
                </Badge>
            </StyledUploadIndicator>

            {isModalOpen && (
                <UploadRetryModal
                    onClose={handleCloseModal}
                    photoCount={photoCount}
                    requestCount={requestCount}
                />
            )}
        </>
    );
};
